<template>
	<el-dialog
	  title="参与/回复帖子"
	  :visible.sync="dialogVisible"
	  width="40%">
	   <el-form :model="dataForm" ref="dataForm">
		   <el-form-item label="RE:" label-width="100px">
			   {{title}}
		   </el-form-item>
		   <el-form-item label="回复内容" label-width="100px">
			   <el-input placeholder="请输入回复内容" v-model="dataForm.content" type="textarea" :rows="6">
				   
			   </el-input>
		   </el-form-item>
		   <el-form-item label="" label-width="100px">
		   			  <el-button @click="dialogVisible=false">取消</el-button>
		   			  <el-button type="success" @click="save">确认发布</el-button>
		   </el-form-item>
	   </el-form>	
	</el-dialog>
</template>

<script>
	import { user_save_pinglun } from "@/api/boke"
	export default{
		data(){
			return{
				dialogVisible:false,
				dataForm:{
					proid:'',
					content:'',
					type:2,
					huifuid:null
				},
				info:{},
				title:''
			}
		},
		watch:{
			dialogVisible(e){
				if(e==false){
					this.dataForm={
						proid:'',
						content:'',
						type:2,
						huifuid:null
					}
					this.title = ''
					this.info = ''
				}
			},
		},
		methods:{
			handlecreate(title,proid){
				this.title = title
				this.dataForm.proid = proid
				this.dialogVisible = true
			},
			handlecreates(title,proid,huifuid){
				this.title = title
				this.dataForm.proid = proid
				this.dataForm.huifuid = huifuid
				this.dialogVisible = true
			},
			save(){
				if(!this.dataForm.content){
					this.$message.error("请输入回复内容");
					return;
				}
				const loading = this.$loading({
				    lock: true,
				    text: '回复中',
				    spinner: 'el-icon-loading',
				    background: 'rgba(0, 0, 0, 0.7)'
				  });
				  user_save_pinglun(this.dataForm).then(()=>{
					  loading.close();
					  this.$message.success("成功");
					  this.dialogVisible = false
					  this.$emit("pingsucc");
				  }).catch(()=>{
					  loading.close();
				  })
			},
		},
	}
</script>

<style lang="scss" scoped>
	
</style>


// WEBPACK FOOTER //
// src/views/luntan/luntan/components/pinglun.vue